import { apiRequest } from '../http.js'

export const clientsApi = {
getAll: async (options = {}) => {
      const data = await apiRequest('/clients', options)
      return data.clients || []
    },

    
    getById: async (id) => {
      const data = await apiRequest(`/clients/${id}`)
      return data.client
    },

    
    getUploadUrl: async (id, { type, filename, contentType }) => {
      const data = await apiRequest(`/clients/${id}/upload-url`, {
        method: 'POST',
        body: JSON.stringify({ type, filename, contentType }),
      })
      return { uploadUrl: data.uploadUrl, publicUrl: data.publicUrl }
    },

    
    getPendingUploadUrl: async ({ type, filename, contentType }) => {
      const data = await apiRequest('/clients/upload-url', {
        method: 'POST',
        body: JSON.stringify({ type, filename, contentType }),
      })
      return { uploadUrl: data.uploadUrl, publicUrl: data.publicUrl }
    },

    
    create: async (clientData) => {
      const data = await apiRequest('/clients', {
        method: 'POST',
        body: JSON.stringify(clientData),
      })
      return { client: data.client, warning: data.warning }
    },

    update: async (id, updates) => {
      const data = await apiRequest(`/clients/${id}`, {
        method: 'PUT',
        body: JSON.stringify(updates),
      })
      return { client: data.client, warning: data.warning }
    },

    
    updateMe: async (updates) => {
      const data = await apiRequest('/clients/me', {
        method: 'PUT',
        body: JSON.stringify(updates),
      })
      return data.client
    },

    delete: async (id) => {
      await apiRequest(`/clients/${id}`, { method: 'DELETE' })
    },
}
